import { Chart } from "react-google-charts";
import React, { useState, useEffect } from "react";
import { Row, Col, Table, Card, Form, Button, Spinner } from 'react-bootstrap';
import { useProvider, Toast } from '../../context/MenuProvider';
import { Link, useNavigate, useParams } from 'react-router-dom';


const GraficoComparativoAno = () => {
  const { 
      crud,
      hasPerms,
  } = useProvider();
  const [isQuantidade, setIsQuantidade] = useState(false);
  const [isSoQuantidade, setIsSoQuantidade] = useState(false);
  const [dadosGrafico, setDadosGrafico] = useState([]);
  const [opcoes, setOpcoes] = useState({});
  const { id, tipo, categoria, modelo } = useParams();
  const ano = new Date().getFullYear();
  const { get } = crud || {};
  
  useEffect(()=>{
    switch(tipo){
      case 'produtos':
        setIsQuantidade(true);
        break
      case 'rede':
        setIsQuantidade(true);
        setIsSoQuantidade(true);
        break
    }
  },[tipo])

  const gerarEstruturaInicial = () => ([
    ["Mês", ano.toString(), (ano - 1).toString(), (ano - 2).toString()],
    ["Jan", 0, 0, 0],
    ["Fev", 0, 0, 0],
    ["Mar", 0, 0, 0],
    ["Abr", 0, 0, 0],
    ["Mai", 0, 0, 0],
    ["Jun", 0, 0, 0],
    ["Jul", 0, 0, 0],
    ["Ago", 0, 0, 0],
    ["Set", 0, 0, 0],
    ["Out", 0, 0, 0],
    ["Nov", 0, 0, 0],
    ["Dez", 0, 0, 0],
  ]);

  useEffect(() => {
    buscarBalancoDiario();
  }, [isQuantidade]);

  const buscarBalancoDiario = async () => {
    const novaData = gerarEstruturaInicial();

    try {
      const response = await get(
        `gvendas/metas/?categoria=${categoria}&is_quantidade=${isQuantidade}&ano__gte=${ano - 2}&ano__lte=${ano}&expand=categoria&filtros=nome,alcancado,ano,mes`,
        "gbarras"
      );

      if (response && response.length) {
        const categoriaNome = response[0].results[0]?.categoria?.nome;

        for (const item of response[0].results) {
          const mesIndex = item.mes;
          if (mesIndex >= 1 && mesIndex <= 12) {
            const valor = parseFloat(item.alcancado);
            if (item.ano === ano) {
              novaData[mesIndex][1] = valor;
            } else if (item.ano === ano - 1) {
              novaData[mesIndex][2] = valor;
            } else if (item.ano === ano - 2) {
              novaData[mesIndex][3] = valor;
            }
          }
        }

        setDadosGrafico(novaData);

        setOpcoes({
          title: `${!categoriaNome?'Sem dados suficientes':`Comparação de ${categoriaNome}`}`,
          chartArea: { width: "50%" },
          hAxis: {
            title: isQuantidade ? "Quantidade" : "Valor",
            minValue: 0,
          },
          vAxis: {
            title: "Mês",
          },
          bars: "horizontal",
          series: {
            0: { color: "#0984e3" }, // ano atual
            1: { color: "#b2bec3" }, // ano - 1
            2: { color: "#636e72" }, // ano - 2
          },
        });
      }
    } catch (err) {
      //alert("Erro ao buscar dados: " + JSON.stringify(err.response || err));
    }
  };

  return (
    <>
      {!isSoQuantidade && (
          <Form.Group controlId="formIsQuantidade" className="fs-5">
            <Form.Check 
              type="switch" 
              label="Por Quantidade"
              checked={isQuantidade}
              onChange={(e) => setIsQuantidade(e.target.checked)} 
            />
          </Form.Group>
      )}
      {dadosGrafico.length > 0 && (
        <Chart
          chartType="BarChart"
          width="100%"
          height="600px"
          data={dadosGrafico}
          options={opcoes}
        />
      )}
    </>
  );
};

export default GraficoComparativoAno;